interface GroupEmployeeWorkOrderAssignmentsEvent {
	workOrderEmployeeIds: number[];
	workOrderEmployeeIdToEmployeeIdLookup: { [workOrderEmployeeId: number]: number; };
	removedEmployeeIdToWorkOrderIdLookup: { [employeeId: number]: number; };
}

export const groupEmployeeWorkOrderAssignments = (event: GroupEmployeeWorkOrderAssignmentsEvent) => {

	const { removedEmployeeIdToWorkOrderIdLookup, workOrderEmployeeIdToEmployeeIdLookup, workOrderEmployeeIds } = event;

	const assignedEmployeeIds = workOrderEmployeeIds.map((_woeId) => {
		if (!workOrderEmployeeIdToEmployeeIdLookup[_woeId]) {
			throw new Error('Could not find work order employee');
		}
		return workOrderEmployeeIdToEmployeeIdLookup[_woeId];
	});

	return [...assignedEmployeeIds, ...Object.keys(removedEmployeeIdToWorkOrderIdLookup).map(Number)];
};

interface GroupTemporaryEmployeeWorkOrderAssignmentsEvent {
	workOrderTemporaryEmployeeIds: number[];
	workOrderTemporaryEmployeeIdToEmployeeIdLookup: { [workOrderTemporaryEmployeeId: number]: number; };
	removedTemporaryEmployeeIdToWorkOrderIdLookup: { [temporaryEmployeeId: number]: number; };
}

export const groupTemporaryEmployeeWorkOrderAssignments = (event: GroupTemporaryEmployeeWorkOrderAssignmentsEvent) => {

	const { removedTemporaryEmployeeIdToWorkOrderIdLookup, workOrderTemporaryEmployeeIdToEmployeeIdLookup, workOrderTemporaryEmployeeIds } = event;

	const assignedEmployeeIds = workOrderTemporaryEmployeeIds.map((_woeId) => {
		if (!workOrderTemporaryEmployeeIdToEmployeeIdLookup[_woeId]) {
			throw new Error('Could not find work order temporary employee');
		}
		return workOrderTemporaryEmployeeIdToEmployeeIdLookup[_woeId];
	});

	return [...assignedEmployeeIds, ...Object.keys(removedTemporaryEmployeeIdToWorkOrderIdLookup).map(Number)];
};
